(function() {
	'use strict';

  angular
	.module('components')
	.component('cartFeeNotice', {
	  templateUrl: '/scripts/components/cart-fee-notice/cart-fee-notice.html',
	  controller: 'CartFeeNoticeComponentController',
	  controllerAs: 'vm',
	  bindings: {
		hidePopover: '<?',
		packageId: '<',
		smallText: '<?',
		pageKey: '<',
		popoverAlign: '<?',
		useDynamicDisplayText: '<?'
	  }
	});
})();